import { render } from "./Customers.vue?vue&type=template&id=1b25affe&scoped=true"
import script from "./Customers.vue?vue&type=script&lang=js"
export * from "./Customers.vue?vue&type=script&lang=js"

import "./Customers.vue?vue&type=style&index=0&id=1b25affe&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1b25affe"

export default script